import { type ErrorComponentProps, useRouter } from "@tanstack/react-router";
import { ErrorFallback } from "@/components/ui/error-fallback";

export function RouteErrorFallback({ error }: Readonly<ErrorComponentProps>) {
	const router = useRouter();

	const resetErrorBoundary = () => {
		router.invalidate();
	};

	return (
		<ErrorFallback error={error} resetErrorBoundary={resetErrorBoundary} />
	);
}
